import React from "react";
import {
  Box,
  Button,
  Card,
  CardContent,
  Container,
  IconButton,
  Stack,
  Typography,
  Chip,
  Grid,
} from "@mui/material";
import {
  CalendarToday,
  LocationOn,
  ChevronLeft,
  ChevronRight,
} from "@mui/icons-material";
import moment from "moment/moment";

const MyEventsAllEventsView = ({ events, handleCreateInterested }) => {

  return (
    <Grid container spacing={3}>
      {events?.map((event, index) => (
        <Grid item xs={12} md={6} key={index}>
          <Card elevation={0} sx={{ borderRadius: 5, border: "1px solid #e0e0e0" }}>
            <CardContent sx={{ p: 3 }}>
              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="flex-start"
                mb={2}
              >
                <Typography variant="h5" fontWeight="bold">
                  {event.event_name}
                </Typography>
                <Chip
                  label="Event"
                  sx={{
                    bgcolor: "#c8e6c9",
                    color: "#2e7d32",
                    fontWeight: 500,
                  }}
                />
              </Box>

              <Stack spacing={1} mb={3}>
                <Box display="flex" alignItems="center" gap={1}>
                  <CalendarToday sx={{ color: "#666" }} />
                  <Typography color="#666">
                    {moment(event.event_start_date).format("MMM DD, YYYY")}
                  </Typography>
                </Box>
                <Box display="flex" alignItems="center" gap={1}>
                  <LocationOn sx={{ color: "#666" }} />
                  <Typography color="#666">{event.event_address}</Typography>
                  <Typography color="#666">{event.city}</Typography>
                  <Typography color="#666">{event.country}</Typography>
                </Box>
              </Stack>

              <Stack direction="row" spacing={2}>
                <Button
                  onClick={() => handleCreateInterested(event.event_id)}
                  variant="outlined"
                  startIcon="✓"
                  sx={{
                    color: "#4caf50",
                    borderColor: "#4caf50",
                    bgcolor: "#e8f5e9",
                    "&:hover": {
                      borderColor: "#2e7d32",
                      bgcolor: "#c8e6c9",
                    },
                  }}
                >
                  Interest
                </Button>
                <Button
                  variant="outlined"
                  startIcon="×"
                  sx={{
                    color: "#f44336",
                    borderColor: "#f44336",
                    bgcolor: "#ffebee",
                    "&:hover": {
                      borderColor: "#d32f2f",
                      bgcolor: "#ffcdd2",
                    },
                  }}
                >
                  Not interested
                </Button>
              </Stack>
            </CardContent>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
};

export default MyEventsAllEventsView;
